import { render } from "./GetStartedPage.vue?vue&type=template&id=3d819556"
import script from "./GetStartedPage.vue?vue&type=script&lang=js"
export * from "./GetStartedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__